import { Navigate } from 'react-router';
import { useDefaultTemplate } from './useDefaultTemplate';

/**
 * `/themes` and `/animation` without a template. These used to land on
 * classic whatever the operator's players get — an operator whose default is
 * modern would tune classic, launch a session and see nothing change.
 */
export function DefaultTemplateRedirect({ base }: { base: '/themes' | '/animation' }) {
  const template = useDefaultTemplate();
  return <Navigate to={`${base}/${template}`} replace />;
}
